import { styledDiv } from "./styles.css";

interface MockComponentProps extends React.HTMLAttributes<HTMLDivElement> {
  children?: React.ReactNode;
}

export const MockComponent = ({
  children,
  className,
  ...rest
}: MockComponentProps) => {
  return (
    <div
      className={className ? `${styledDiv} ${className}` : styledDiv}
      {...rest}
    >
      {children}
    </div>
  );
};

MockComponent.displayName = "MockComponent";
